import { useApi } from '@/composables/useApi'

const api = useApi()
export default {
  namespaced: true,
  state: {
    current_pasta_id: null,
    pastas: [],
    AllMainfolders: [],
    pastaAtual: {
      id: 0,
      nome_pasta: null,
      endereco_aws_pasta: null,
      id_main: null,
      id_user: null,
      data_pasta: null,
      uid_conteudo: null,
      chave_aws_pasta: null,
    },
    params: {
      id_main: 0,
    },
  },
  getters: {},
  mutations: {
    setPastas(state, payload) {
      state.pastas = payload
    },
    setIdMainParams(state, payload) {
      state.params.id_main = payload
    },
    setpastaAtual(state, payload) {
      state.pastaAtual = payload
    },
    setCurrentPastaId(state, payload) {
      state.current_pasta_id = payload
    },
    setAllPastaMain(state, payload) {
      state.AllMainpastas = payload
    },
  },
  actions: {
    clearFolderAtual({ commit }) {
      commit('setpastaAtual', {
        id: 0,
        nome_pasta: null,
        endereco_aws_pasta: null,
        id_main: null,
        id_user: null,
        data_pasta: null,
        uid_conteudo: null,
        chave_aws_pasta: null,
      })
    },
    async getAllPastaUser({ state, commit, rootState }) {
      return new Promise(async (resolve, reject) => {
        const id = localStorage.getItem('uidConteudo')
        try {
          await api.get(`/pastaUser?id_main=${state.params.id_main}&id_conteudo=${id}`, {
          })
            .then(resp => {
              console.log(resp)
              const formData = resp.data
              formData.map(v => v.is_selected = false)
              commit('setAllPastaMain', formData)
              resolve(formData)
            })
        } catch (error) {
          reject(error)
        }
      })
    },
  },
}
